// Keep this version string in sync with VENUE_AGREEMENT_VERSION in
// functions/src/venues/index.js — the backend rejects consent submissions
// that don't match the current version.
export const VENUE_AGREEMENT_VERSION = "venue-platform-event-hosting-agreement-2026-08-12";
export const VENUE_AGREEMENT_NAME = "Venue Platform and Event Hosting Agreement";

// A user has "signed" if their stored consent is accepted and matches the
// agreement version currently in force — re-signing is required whenever
// the version bumps.
export const isVenueAgreementSigned = (userData) =>
  !!(
    userData?.venueAgreementConsent?.accepted === true &&
    userData?.venueAgreementConsent?.agreementVersion === VENUE_AGREEMENT_VERSION
  );

// Venue payouts are wired up once the venue role is linked to a verified
// Stripe account. `isVenueOwner` is only set once Stripe reports the account
// details as submitted (see HostOnboarding.js) or once an existing verified
// account is linked to the venue role (see VenuePayoutModal).
export const hasPayoutsReady = (userData) =>
  !!(userData?.accountId && userData?.isVenueOwner === true);

// Venues get paid through the same Stripe Connect account hosts use, so
// someone who already finished onboarding as a host doesn't have to go
// through Stripe a second time — we just link their existing account to
// the venue role.
export const hasVerifiedStripeAccount = (userData) =>
  !!(userData?.accountId && (userData?.isHost === true || userData?.isVenueOwner === true));
